import styled from "styled-components/macro";
import { colorLightGray2, colorWhite } from "../../styles/globalVariables";
import { alert, close } from "../../assets/components/svgs";
import ModalBackground from "./ModalBackground";
import { useTheme } from "../../context/themeContext";
import { ActiveProp } from "../../styles/interfaces";
import { Button } from "../../styles/Shared";

const StyledDialog = styled.div<ActiveProp>`
  height: 12.625rem;
  background-color: rgb(${colorWhite});
  filter: drop-shadow(0px 25px 50px rgba(31, 41, 55, 0.25));
  border-radius: 7px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const HeaderContainer = styled.div`
  background-color: rgb(${colorLightGray2});
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > div > h1 {
    font-weight: 600;
  }
  & > button > svg {
    height: 0.875rem;
    width: 0.875rem;
    margin-right: 1rem;
  }
  & > div {
    padding-left: 1.5rem;
    display: flex;
    align-items: center;
    svg {
      margin-right: 0.625rem;
    }
  }
`;

const DialogTextContainer = styled.div`
  width: 40.9ch;
  margin-inline: 1.5625rem;
  margin-top: 0.75rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.625rem;
  margin-top: auto;
  padding-right: 1.5rem;
  margin-bottom: 1.25rem;
`;

type Props = {
  title: string;
  text: React.ReactNode;
  isActive: boolean;
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
  primaryButtonText?: string;
  primaryOnClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  primaryButtonWidth?: string;
  secondaryButtonText?: string;
  secondaryOnClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  secondaryButtonWidth?: string;
  tertiaryButtonText?: string;
  tertiaryOnClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  tertiaryButtonWidth?: string;
  dangerButtonText?: string;
  dangerOnClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  dangerButtonWidth?: string;
};

const Dialog = ({
  title,
  text,
  isActive,
  setIsActive,
  primaryButtonText,
  primaryOnClick,
  primaryButtonWidth,
  secondaryButtonText,
  secondaryOnClick,
  secondaryButtonWidth,
  tertiaryButtonText,
  tertiaryOnClick,
  tertiaryButtonWidth,
  dangerButtonText,
  dangerOnClick,
  dangerButtonWidth,
}: Props) => {
  return (
    <ModalBackground isActive={isActive}>
      <StyledDialog>
        <HeaderContainer>
          <div>
            {dangerButtonText && alert}
            <h1>{title}</h1>
          </div>
          <button onClick={() => setIsActive(false)}>{close}</button>
        </HeaderContainer>
        <DialogTextContainer>{text}</DialogTextContainer>
        <ButtonContainer>
          {(secondaryButtonText || tertiaryButtonText) && (
            <Button
              color={secondaryButtonText ? "secondary" : "tertiary"}
              width={
                secondaryButtonText ? secondaryButtonWidth : tertiaryButtonWidth
              }
              onClick={secondaryOnClick || tertiaryOnClick}
              theme={useTheme().theme}
            >
              {secondaryButtonText || tertiaryButtonText}
            </Button>
          )}
          <Button
            color={primaryButtonText ? "primary" : "secondary"}
            width={primaryButtonText ? primaryButtonWidth : dangerButtonWidth}
            onClick={primaryOnClick || dangerOnClick}
          >
            {primaryButtonText || dangerButtonText}
          </Button>
        </ButtonContainer>
      </StyledDialog>
    </ModalBackground>
  );
};

export default Dialog;
